import { render } from "./MiddlePage.vue?vue&type=template&id=267177a7&scoped=true"
import script from "./MiddlePage.vue?vue&type=script&lang=js"
export * from "./MiddlePage.vue?vue&type=script&lang=js"

import "./MiddlePage.vue?vue&type=style&index=0&id=267177a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267177a7"]])

export default __exports__